import { z } from 'zod';

export const vehicleSchema = z.object({
  registration_number: z
    .string()
    .min(1, 'Registration number is required')
    .max(20, 'Registration number must be 20 characters or less'),
  make: z.string().max(100).nullable().optional(),
  model: z.string().max(100).nullable().optional(),
  variant: z.string().max(100).nullable().optional(),
  year_of_manufacture: z
    .number()
    .min(1900, 'Year must be 1900 or later')
    .max(new Date().getFullYear() + 1, 'Year cannot be in the future')
    .nullable()
    .optional(),
  color: z.string().max(50).nullable().optional(),
  vin_chassis: z.string().max(50).nullable().optional(),
  engine_number: z.string().max(50).nullable().optional(),
  fuel_type: z.enum(['petrol', 'diesel', 'cng', 'electric', 'hybrid']).nullable().optional(),
  transmission: z.enum(['manual', 'automatic', 'cvt']).nullable().optional(),
  owner_id: z.number().nullable().optional(),
  insurance_provider: z.string().max(100).nullable().optional(),
  insurance_policy_number: z.string().max(50).nullable().optional(),
  insurance_expiry: z.string().nullable().optional(), // ISO date string
  site_id: z.number().nullable().optional(),
});

export type VehicleFormValues = z.infer<typeof vehicleSchema>;

export const defaultVehicleValues: VehicleFormValues = {
  registration_number: '',
  make: null,
  model: null,
  variant: null,
  year_of_manufacture: null,
  color: null,
  vin_chassis: null,
  engine_number: null,
  fuel_type: null,
  transmission: null,
  owner_id: null,
  insurance_provider: null,
  insurance_policy_number: null,
  insurance_expiry: null,
  site_id: null,
};
